type CanAccessParams<
    RecordType extends Record<string, any> = Record<string, any>,
> = {
    action: string;
    resource: string;
    record?: RecordType;
};

// Default-deny: every react-admin resource is admin-only. Feature-scoped
// surfaces are gated by ROUTE_ACCESS, not here.
export const canAccess = <
    RecordType extends Record<string, any> = Record<string, any>,
>(
    role: string,
    _params: CanAccessParams<RecordType>
) => role === 'admin';
